module.exports = __webpack_public_path__ + "img/close__modal__reel.f7a5c229.svg";